<template>
  <div class="vuse-content-wrapper">
    <vuse-section-definition
        :breadcrumbs="breadcrumbs"
        :title="page"
        icon="mdi-image-filter-black-white"
    ></vuse-section-definition>
    <v-container fluid>
      <template>
        <v-simple-table>
          <template v-slot:default>
            <thead>
            <tr>
              <th class="text-left">
                Font Name
              </th>
              <th class="text-left">
                Url
              </th>
              <th class="text-left">
                Add File
              </th>
            </tr>
            </thead>
            <tbody>
            <tr
                v-for="item in fonts"
                :key="item.name"
            >
              <td>{{ item.name }}</td>
              <td>{{ item.url }}</td>
              <td>
                <v-file-input
                    title="upload file font"
                    hide-input
                    truncate-length="15"
                    @change="changeFile(item,$event)"
                ></v-file-input>
              </td>
            </tr>
            </tbody>
          </template>
        </v-simple-table>
      </template>
    </v-container>
  </div>
</template>

<script>
import {mapGetters} from "vuex";
// import {GET_DETAIL_TEMPLATE} from "@/store/modules/template";
import {UPLOAD_FONT_BY_TEMPLATE, GET_ALL_FONT} from "@/store/modules/font";

export default {
  name: "FontsTemplate",
  data() {
    return {
      page: "Fonts",
      breadcrumbs: [
        {
          text: "Templates Setting",
          disabled: true,
        },
        {
          text: "Templates",
          disabled: false,
          href: '/template_setting/templates',
        },
        {
          text: "Fonts",
          disabled: false,
        },
      ],
      // fonts: []
    }
  },
  // watch: {
  //   fonts(newVal) {
  //     if (newVal && newVal.fonts) {
  //       this.fonts = newVal.fonts
  //     }
  //   }
  // },
  computed: {
    ...mapGetters({
      // templateDetail: "templateDetail",
      fonts: "fonts",
    }),
  },
  async created() {
    // await this.$store.dispatch(`${GET_DETAIL_TEMPLATE}`, '75');
    await this.$store.dispatch(`${GET_ALL_FONT}`);
  },
  methods: {
    async changeFile(item, file) {

      let form = new FormData();
      form.append("id", item.id);
      form.append("upload", file);
      await this.$store.dispatch(`${UPLOAD_FONT_BY_TEMPLATE}`, form).then(data => {
        if (data.status){
          item.url = data.data
          this.$toasted.success('Update successful!', {
            duration: 1000,
            position: 'top-center'
          })
        }
      });
    }
  }
}
</script>

<style scoped>
.btn-add-templates {
  background-color: #71BEC8 !important;
  color: white !important;
  border-radius: 36px !important;
}
</style>
